export const name = "UNIX_DATE";
export const summary = `Converts a \`DATE\` value to the number of days since 1970-01-01.`;
export const reference = `
## UNIX_DATE

Converts a \`DATE\` value to the number of days since 1970-01-01.

\`\`\`
UNIX_DATE(date_expression)
\`\`\`

### Description

Returns the number of days since \`1970-01-01\`.


### Return Data Type

INT64


### Example



\`\`\`
SELECT UNIX_DATE(DATE '2008-12-25') AS days_from_epoch;

/*-----------------*
 | days_from_epoch |
 +-----------------+
 | 14238 |
 *-----------------*/
\`\`\`




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
`;
